import { Component } from '@angular/core';

@Component({
  selector: 'app-lollipop-chart',
  template: '<app-chart-output></app-chart-output>'
})
export class LollipopChartComponent {

}
